import React, {FC, useMemo} from 'react';

import {Trans} from '../../../../libs/shared/helpers/src/internationalization/react';
import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {DropdownBoxCoordinator} from '../../../../libs/shared/ui/src/components/boxedInputs/dropdownBoxCoordinator';
import {SimpleDropdown} from '../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown';
import {SimpleDropdownItem} from '../../../../libs/shared/ui/src/components/dropdowns/simpleDropdownItem';
import {PopoverTransferProps} from '../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {buildCustomFieldLabel} from '../../../../srcCommon/helpers/models/customFieldHelpers';
import {CustomFieldModel} from '../../../models/api/customFieldModel';
import {DropdownSeparator} from '../dropdowns/dropdownSeparator';
import {InlineEditingInputDisplay} from './inlineEditingInputDisplay';

/*
 * Props.
 */

interface InlineEditingDropdownProps {
  value: string;
  customField: CustomFieldModel;
  onEditSave: HandlerOf<string>;
}

/*
 * Component.
 */

export const InlineEditingEnumDropdown: FC<InlineEditingDropdownProps> = (props) => {
  const {value, customField, onEditSave} = props;
  const {enumValues} = customField;

  const hasValues = Boolean(enumValues && enumValues.length > 0);
  const label = useMemo(() => buildCustomFieldLabel(value, customField), [value, customField]);

  return (
    <InlineEditingInputDisplay>
      <DropdownBoxCoordinator
        value={label ?? '-'}
        renderDropdown={(popoverProps: PopoverTransferProps) => (
          <SimpleDropdown {...popoverProps} width={popoverProps.anchorWidth}>
            {enumValues?.map((enumValue) => (
              <SimpleDropdownItem
                onSelect={() => onEditSave(enumValue.value)}
                key={enumValue.value}
                isChecked={value === enumValue.value}
              >
                {enumValue.label}
              </SimpleDropdownItem>
            ))}

            {hasValues && <DropdownSeparator />}

            <SimpleDropdownItem onSelect={() => onEditSave('')} key="enum-no-value" isChecked={!label}>
              <Trans id="create-form-custom-field-enum-none">No value</Trans>
            </SimpleDropdownItem>
          </SimpleDropdown>
        )}
        noMargin
      />
    </InlineEditingInputDisplay>
  );
};
